import { formatDatetime } from 'helpers/timezone';

const Deleted = ({ deletedBy }) => {
  return (
    <main className="th-main">
      <section className="th-canvas">
        <h3 className="f2 fw4 ma0 pa0 tc mt10">
          {`This record has been deleted by ${
            deletedBy.email
          } at ${formatDatetime(deletedBy.deletedAt)}`}
        </h3>
      </section>
    </main>
  );
};

export default Deleted;
